<template>
    <div class="sponsor-slide">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <!-- Mobile Slide -->
                <template v-for="i in Math.ceil(banner.slides.length / 4)">
                    <div :key="i" class="swiper-slide .mobile d-lg-none">
                        <v-row>
                            <v-col v-for="j in 6" :key="j" cols="4">
                                <v-card v-if="banner.slides[(i-1)*6+j-1]" :img="banner.slides[(i-1)*6+j-1].image" color="grey lighten-3" outlined max-width="220" class="border-radius-16 mx-auto">
                                    <v-responsive :aspect-ratio="1" />
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                </template>
                <!--// Mobile Slide -->
                <!-- PC Slide -->
                <template v-for="i in Math.ceil(banner.slides.length / 10)">
                    <div :key="i" class="swiper-slide d-none d-lg-block">
                        <v-row class="sponsor-list">
                            <v-col v-for="j in 10" :key="j" class="sponsor-list__item">
                                <v-card v-if="banner.slides[(i-1)*10+j-1]" :img="banner.slides[(i-1)*10+j-1].image" color="grey lighten-3" outlined max-width="220" class="border-radius-16 mx-auto">
                                    <v-responsive :aspect-ratio="1" />
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                </template>
                <!--// PC Slide -->
            </div>
        </div>
        <v-btn icon outlined x-large class="swiper-prev">
            <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn icon outlined x-large class="swiper-next">
            <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
    </div>
</template>

<script>
import api from "@/api";
import Swiper from "swiper/bundle";

export default {
    data(){
        return {
            banner: {
                slides: []
            }
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            var { banner } = await api.v1.banners.get({ params: { code: "sponsor" } });
            this.banner = banner;
            this.$nextTick(() => {
                this.swiper = new Swiper(".sponsor-slide .swiper-container", {
                    allowTouchMove: true,
                    spaceBetween: 16,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    speed: 500,
                    loop: true,
                    navigation: {
                        nextEl: ".sponsor-slide .swiper-next",
                        prevEl: ".sponsor-slide .swiper-prev",
                    },
                    breakpoints: {
                        768: {
                            spaceBetween: 24,
                        },
                    },
                });

                this.swiper = new Swiper(".sponsor-slide.mobile .swiper-container", {
                    allowTouchMove: true,
                    spaceBetween: 16,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    speed: 500,
                    loop: true,
                    navigation: {
                        nextEl: ".sponsor-slide .swiper-next",
                        prevEl: ".sponsor-slide .swiper-prev",
                    },
                    breakpoints: {
                        768: {
                            spaceBetween: 24,
                        },
                    },
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.sponsor-slide {
    position: relative;
    .swiper-prev {
        left: -50px;
        transform: translate(-100%, -50%);
    }
    .swiper-next {
        right: -50px;
        transform: translate(100%, -50%);
    }
}
.sponsor-list {
    flex-wrap: wrap;
    position: relative;
    &__item {
        flex-basis: 20%;
        max-width: 20%;
    }
}
</style>